import MahindraLogo from "@/components/MahindraLogo";

const CAMPUS_IMAGE = `${process.env.PUBLIC_URL || ""}/login/campus-entrance.png`;

/** Left brand pane — campus photo + Mahindra red wash (matches MU One). */
export default function LoginBrandPanel() {
  return (
    <aside
      className="relative hidden min-h-screen flex-col justify-between overflow-hidden bg-[#B60F2A] lg:flex"
      data-testid="login-brand-panel"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.4) 0%, transparent 40%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.25) 0%, transparent 45%)",
        }}
      />
      <div className="absolute inset-0">
        <img
          src={CAMPUS_IMAGE}
          alt=""
          aria-hidden
          className="h-full w-full object-cover opacity-35 mix-blend-luminosity"
        />
      </div>

      <div className="relative p-10">
        <div className="inline-flex max-w-full items-center gap-4 rounded-2xl bg-white/95 px-4 py-3 shadow-[0_12px_40px_rgba(0,0,0,0.18)] ring-1 ring-white/80 backdrop-blur-sm">
          <MahindraLogo size="compact" transparent className="max-w-[160px] shrink-0" />
          <div className="min-w-0 border-l border-[#E2E8F0] pl-4">
            <div className="font-heading text-sm font-extrabold leading-snug tracking-tight text-[#0F172A]">
              QFace Attendance System
            </div>
            <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.2em] text-[#94A3B8]">
              Mahindra University
            </div>
          </div>
        </div>
      </div>

      <div className="relative p-10 md:p-14">
        <h1 className="font-heading text-4xl font-extrabold leading-tight tracking-tighter text-white md:text-5xl">
          Every roll call, connected.
        </h1>
        <p className="mt-4 max-w-md text-lg leading-relaxed text-white/80">
          Live sessions, attendance logs, and face-recognition data from every school — in one secure dashboard.
        </p>
      </div>

      <div className="relative p-10 text-xs font-medium tracking-wide text-white/60">
        &ldquo;Global Thinkers. Engaged Leaders.&rdquo;
      </div>
    </aside>
  );
}
